import { gsap } from "gsap";

export default class TransitionFlow {
    constructor(holder) {
        this.elements = {
            holder: holder
        };

        this.elements.transitionElem = this.elements.holder.querySelector(
            ".js-flow-transition"
        );
        this.elements.progress = this.elements.holder.querySelector(
            ".js-flow-progress"
        );
        this.elements.transitionLayers = this.elements.transitionElem.querySelectorAll(
            ".js-flow-transition-layer"
        );
        this.elements.items = this.elements.holder.querySelectorAll(
            ".js-flow-item"
        );
        this.elements.nextTriggers = this.elements.holder.querySelectorAll(
            ".js-flow-trigger-next"
        );
        this.elements.prevTriggers = this.elements.holder.querySelectorAll(
            ".js-flow-trigger-prev"
        );
        this.elements.inputTriggers = this.elements.holder.querySelectorAll(
            'input[name^="input-group"]'
        );

        this.answers = [];

        this.currentItem = 1;

        this.onTriggerClick = this.onTriggerClick.bind(this);

        if (!this.elements.items.length) {
            return;
        }

        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.nextTriggers.length; i++) {
            const element = this.elements.nextTriggers[i];
            element.addEventListener("click", () =>
                this.onTriggerClick("next")
            );
        }
        for (let i = 0; i < this.elements.prevTriggers.length; i++) {
            const element = this.elements.prevTriggers[i];
            element.addEventListener("click", () =>
                this.onTriggerClick("prev")
            );
        }
        for (let i = 0; i < this.elements.inputTriggers.length; i++) {
            const element = this.elements.inputTriggers[i];
            element.addEventListener("change", () => this.updateForm());
            element.addEventListener("blur", () => this.updateForm());
        }
    }

    goToItem(itemNum) {
        const self = this;

        let tlIn = gsap.timeline({
            onComplete: onTlInComplete,
            onCompleteParams: [self],
            paused: true
        });
        tlIn.set(this.elements.transitionElem, { zIndex: 5 });
        tlIn.staggerTo(
            this.elements.transitionLayers,
            0.5,
            { scaleY: 1, transformOrigin: "top", ease: "power2.inOut" },
            0.2
        );

        let tlUpdate = gsap.timeline({
            onComplete: onTlUpdateComplete,
            onCompleteParams: [self],
            paused: true
        });
        tlUpdate.set(this.elements.items, { opacity: 0, display: "none" });
        tlUpdate.set(this.elements.items[itemNum - 1], {
            opacity: 1,
            display: "block"
        });

        let tlOut = gsap.timeline({
            onComplete: onTlOutComplete,
            onCompleteParams: [self],
            paused: true
        });
        tlOut.staggerTo(
            this.elements.transitionLayers,
            0.5,
            { scaleY: 0, transformOrigin: "bottom", ease: "power2.inOut" },
            -0.2
        );
        tlOut.set(this.elements.transitionElem, { zIndex: -1 });

        tlIn.play(0);

        function onTlInComplete() {
            tlUpdate.play(0);
            self.currentItem = itemNum;
            self.updateNavigation();
        }

        function onTlUpdateComplete() {
            tlOut.play(0);
        }

        function onTlOutComplete() {
            self.updateProgress();
        }
    }

    onTriggerClick(goTo) {
        if (goTo == "next") {
            if (this.currentItem < this.elements.items.length) {
                this.goToItem(this.currentItem + 1);
            }
        } else if (goTo == "prev") {
            if (this.currentItem > 0) {
                this.goToItem(this.currentItem - 1);
            }
        }
    }

    updateForm() {
        const checkedInputs = this.elements.items[
            this.currentItem - 1
        ].querySelectorAll(
            'input[name="input-group-' + this.currentItem + '"]:checked'
        );

        if (checkedInputs.length) {
            let values = [];

            for (let i = 0; i < checkedInputs.length; i++) {
                const input = checkedInputs[i];
                values.push(input.value);
            }

            this.answers["item" + this.currentItem] = {
                item: this.currentItem,
                answer: values
            };
            const input = this.elements.holder.querySelector(
                "input[name='itemanswer" + this.currentItem + "']"
            );
            input.focus();
            input.value = values;
            input.blur();
        } else {
            delete this.answers["item" + this.currentItem];
            const input = this.elements.holder.querySelector(
                "#itemanswer" + this.currentItem
            );
            input.focus();
            input.value = "";
            input.blur();
        }

        this.updateNavigation();
    }

    updateProgress() {
        if (!this.elements.progress) {
            return;
        }

        const dur = 0.35;

        const percentage =
            ((this.currentItem - 1) * 100) / this.elements.items.length;
        const valElem = this.elements.progress.querySelector(".js-value");
        const currentVal = { val: parseInt(valElem.textContent) };

        gsap.to(currentVal, dur, {
            val: percentage,
            onUpdate: function() {
                valElem.innerHTML = currentVal.val.toFixed();
            }
        });
        gsap.to(this.elements.progress.querySelector(".js-inner-bar"), {
            width: percentage + "%",
            duration: dur,
            ease: "power2.inOut"
        });
    }

    updateNavigation() {
        let nextDisabled =
            this.currentItem >= this.elements.items.length ? true : false;

        if (!this.answers["item" + this.currentItem]) {
            nextDisabled = true;
        }

        const prevDisabled = this.currentItem <= 1 ? true : false;

        // HIDE NEXT BUTTON ON THE LAST PAGE
        const displayNextButton =
            this.currentItem >= this.elements.items.length
                ? "none"
                : "inline-block";

        for (let i = 0; i < this.elements.nextTriggers.length; i++) {
            const element = this.elements.nextTriggers[i];

            // CHANGE TEXT ON SECOND LAST ITEM
            const buttonNextText =
                this.currentItem + 1 >= this.elements.items.length
                    ? element.dataset.labelConfirm
                    : element.dataset.labelDefault;

            element.disabled = nextDisabled;
            element.style.display = displayNextButton;

            if (element.innerHTML != "") {
                element.innerHTML = buttonNextText;
            }
        }

        for (let i = 0; i < this.elements.prevTriggers.length; i++) {
            const element = this.elements.prevTriggers[i];
            element.disabled = prevDisabled;
        }
    }
}
